<div class="search-product-container" [style.width]="width">
  <div #trigger class="search-product-trigger" [style.width]="width">
    <div class="smart-input-wrapper smart-input" [class.focused]="isFocused" [class.disabled]="disabled" [style.width]="width">

      <input #searchproductInput id="search_product_input" type="text" class="search-input smart-input-field"
        [placeholder]="placeholder" [(ngModel)]="searchnameProduct" (focus)="onInputFocus($event)" autocomplete="off"
        tabindex="1" (keydown.enter)="$event.preventDefault()" [disabled]="disabled" />

      <!-- Spinner de chargement -->
      <div class="spinner-container" [class.visible]="loadingProduct">
        <svg class="spinner" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
        </svg>
      </div>

      <!-- Boutons d'action -->
      <div class="action-buttons">
        @if (clearButtonVisible) {
        <button type="button" class="custom-icon-button error" (mousedown)="$event.preventDefault()" (click)="clearProductSearch()" title="Effacer"
          aria-label="Effacer" [disabled]="disabled">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="currentColor"
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
        }
        <button type="button" class="custom-icon-button primary" (mousedown)="$event.preventDefault()" (click)="openProductsDialog(searchnameProduct)"
          title="Recherche avancée" aria-label="Recherche avancée" [disabled]="disabled">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="currentColor"
              d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
        </button>
      </div>

    </div>
  </div>
</div>

<!-- PANEL DE RÉSULTATS (Overlay) -->
<ng-template #panel>
  <div class="search-product-panel" role="listbox">
    @for (option of productsApiResponse; track option.id) {
    <div class="product-option" role="option" [attr.data-id]="option.id" [class.active]="selectedIndex === $index"
      (mousedown)="$event.preventDefault()" (click)="onOptionClick(option)">
      <span class="product-name">{{ option.name }}</span>
      @if (option.is_sold === '0') {
      <svg viewBox="0 0 24 24" width="16" height="16" class="warning-icon">
        <path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
      }
      @if (is_ht ? option.ptx : option.pti) {
      <span class="product-price" [class.price-ttc]="!is_ht" [class.price-ht]="is_ht">
        {{ formatPrice(is_ht ? option.ptx : option.pti) }}
      </span>
      }
    </div>
    } @empty {
   
    }
  </div>
</ng-template>

<!-- PANEL D'ERREUR (Overlay) -->
<ng-template #errorPanel>
  <div class="hint-error-panel">
    <span class="hint-error-text">Aucun produit trouvé</span>
  </div>
</ng-template>